import { render, staticRenderFns } from "./CardEnvioImagenes.vue?vue&type=template&id=1288e8fa"
import script from "./CardEnvioImagenes.vue?vue&type=script&lang=js"
export * from "./CardEnvioImagenes.vue?vue&type=script&lang=js"
import style0 from "./CardEnvioImagenes.vue?vue&type=style&index=0&id=1288e8fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports